import React, { useState } from "react";
import axios from 'axios';
import { KRAKEN_URL } from '../../../../../constants'

//Estilos
import '../../../css/Configuracion.css'

//Componentes bootstrap
import { Modal } from "react-bootstrap";
import { Trash } from 'react-bootstrap-icons';
import { toast } from "react-toastify";

function ModalEliminarUsuarioContacto(props) {
    const contacto = props.children;
    const [status, setStatus] = useState(false);

    function eliminarContacto() {
        setStatus(true);
        axios.post(KRAKEN_URL + 'empresa/usuario/contactos/delete',
            {
                "contactoId": contacto.contactoId
            }
        ).then((res) => {
            if (res.data.result.code === 200) {
                setStatus(false);
                toast.success(res.data.result.message,{
                    position:"top-center",
                    autoClose: 4500, 
                });
                props.onUpdate();//Actualiza el listado, llamando a la función padre para actualizarlo  
                props.onHide();//Cierra el modal, llamando a la función padre para cerrarlo 
            } else {
                setStatus(false);
                toast.warning(res.data.result.message,{
                    position:"top-center",
                    autoClose: 4500, 
                });
                toast.warning(res.data.result.suggestion,{
                    position:"top-center",
                    autoClose: 4500, 
                });
            }
        }).catch((error) => {
            setStatus(false);
            toast.error("Hubo un error, no se pudo eliminar el contacto de este usuario.",{
                position:"top-center",
                autoClose: 4500, 
            });
        })
    }

    return (
        <section className="text-center">
            <Modal
                show={props.show}
                //onHide={props.onHide}
                size="sm"
                id="modalEliminarContacto"
                centered
            >
                <Modal.Header className="modal-header-empresa-usuario" closeButton onHide={props.onHide}>
                    <p><Trash size={22} color="#5B4B51" />   Eliminar contacto de {contacto.username}</p>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        &nbsp;¿Está seguro que desea eliminar a {contacto.contacto} de {contacto.username}?
                    </p>
                    <div className="d-flex justify-content-center">
                        <button
                            className="m-1 button-default-confirmar"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Confirmar"
                            onClick={e => eliminarContacto()}
                        >{status ?
                            <span>Eliminando...</span>
                            : <span>Confirmar</span>}
                        </button>
                        <button
                            className="m-1 button-default-cancelar"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Cancelar"
                            onClick={props.onHide}
                        ><span>Cancelar</span>
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </section>
    )
}

export default ModalEliminarUsuarioContacto;